import triggerTracking from '@blueprint/tracking/dist/Tracking';
import {
    ActionAfterAuth,
    AuthModalTracking
} from 'shared/components/AuthModal/AuthModal.types';
import RegistrationFormData from './interfaces/RegistrationFormData';
import { RegisterUserPayload } from '../../../queries/authentication/authentication';
import { authTaxonomyObject } from './constants/taxonomy';

type TrackAuthSubmit = (props: {
    payload: RegisterUserPayload;
    formData: RegistrationFormData;
    eventLabel?: ActionAfterAuth['eventLabel'];
}) => void;

export const trackAuthSubmit: TrackAuthSubmit = ({
    payload,
    formData,
    eventLabel = 'registration_modal'
}) => {
    const { situation, consent__insights__24 } = formData;
    const { success, errorCode } = payload;

    if (errorCode === 'EMAIL_EXISTS') {
        triggerTracking({
            event: 'GAEvent',
            eventCategory: 'registration',
            eventAction: 'failure_account_exists',
            eventLabel
        });
    }

    if (!success) return;

    triggerTracking<AuthModalTracking>({
        event: 'GAEvent',
        eventCategory: 'registration',
        eventAction: 'success',
        eventLabel,
        taxonomy: authTaxonomyObject.zpg.register
    });
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'registration',
        eventAction: 'about_me',
        eventLabel: situation ? situation : 'blank'
    });

    if (consent__insights__24 !== undefined) {
        triggerTracking({
            event: 'GAEvent',
            eventCategory: 'permission opt-in',
            eventAction: consent__insights__24 ? 'optin_both' : 'optin_neither',
            eventLabel
        });
    }
};
